interface QueuedRequest<T> {
	resolve: (value: T) => void
	reject: (error: unknown) => void
}

export class RefreshQueue<T = string> {
	private pending: QueuedRequest<T>[] = []
	private active = false

	get isRefreshing(): boolean {
		return this.active
	}

	begin(): void {
		this.active = true
	}

	end(): void {
		this.active = false
	}

	enqueue(): Promise<T> {
		return new Promise<T>((resolve, reject) => {
			this.pending.push({ resolve, reject })
		})
	}

	resolveAll(value: T): void {
		for (const queued of this.pending) {
			queued.resolve(value)
		}
		this.pending = []
	}

	rejectAll(error: unknown): void {
		for (const queued of this.pending) {
			queued.reject(error)
		}
		this.pending = []
	}
}
